export const WEEKLY_OFF_INITIAL_STATE = {
    days: "",
    repeat: ""
};
